import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bg-about-background bg-top pb-20 bg-[length:130rem] h-full bg-no-repeat bg-white pt-28" }
const _hoisted_2 = { class: "mx-auto max-w-4xl" }
const _hoisted_3 = { class: "flex flex-col gap-4 md:flex-row md:items-start md:justify-between" }
const _hoisted_4 = { class: "text-gray-900 text-2xl font-semibold mt-2" }
const _hoisted_5 = { class: "text-sm text-gray-600 mt-1 flex items-center gap-2" }
const _hoisted_6 = { class: "bg-primary/10 border border-primary/30 rounded-2xl shadow-sm px-6 py-4 w-full md:w-72" }
const _hoisted_7 = { class: "flex items-center justify-between" }
const _hoisted_8 = { class: "text-3xl font-semibold text-gray-900" }
const _hoisted_9 = ["aria-valuenow"]
const _hoisted_10 = { class: "mt-6 mb-3 text-sm font-medium text-gray-700 flex items-center gap-2" }
const _hoisted_11 = { class: "space-y-3" }
const _hoisted_12 = { class: "flex items-center" }
const _hoisted_13 = { class: "flex items-center mr-3" }
const _hoisted_14 = ["id", "checked", "onChange"]
const _hoisted_15 = { class: "relative mr-3 inline-flex items-center justify-center w-9 h-9 overflow-hidden rounded-full bg-[#f6f1ec] border border-gray-200" }
const _hoisted_16 = { class: "text-xs text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_BookOpenIcon = _resolveComponent("BookOpenIcon")!
  const _component_Squares2X2Icon = _resolveComponent("Squares2X2Icon")!
  const _component_PlayCircleIcon = _resolveComponent("PlayCircleIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createVNode(_component_Breadcrumb, { crumbs: _ctx.breadcrumbItems }, null, 8, ["crumbs"]),
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.course.title), 1),
          _createElementVNode("p", _hoisted_5, [
            _createVNode(_component_BookOpenIcon, { class: "h-4 w-4 text-primary" }),
            _cache[0] || (_cache[0] = _createTextVNode(" Modules and learning progress "))
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-sm font-medium text-gray-600" }, " Progress ", -1)),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.computeCourseProgress(_ctx.course)) + "% ", 1)
          ]),
          _createElementVNode("div", {
            "aria-valuenow": _ctx.computeCourseProgress(_ctx.course),
            "aria-valuemax": "100",
            "aria-valuemin": "0",
            class: "mt-3 flex w-full h-2 rounded-full overflow-hidden bg-gray-200",
            role: "progressbar"
          }, [
            _createElementVNode("div", {
              style: _normalizeStyle({ width: _ctx.computeCourseProgress(_ctx.course) + '%' }),
              class: "flex flex-col justify-center overflow-hidden bg-primary text-xs text-white text-center whitespace-nowrap transition duration-500"
            }, null, 4)
          ], 8, _hoisted_9)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_Squares2X2Icon, { class: "h-4 w-4 text-primary" }),
        _cache[2] || (_cache[2] = _createTextVNode(" Modules "))
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.course.modules, (module, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createVNode(_component_Accordion, {
            "is-open": module.show,
            progress: _ctx.computeModuleProgress(module),
            "onUpdate:isOpen": ($event: any) => (module.show = $event)
          }, {
            title: _withCtx(() => [
              _createTextVNode(_toDisplayString(module.title), 1)
            ]),
            "content-count": _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.getContentCount(module)), 1)
            ]),
            "progress-label": _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode(" Progress ")
            ])),
            "progress-percent": _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.computeModuleProgress(module)) + "% Complete ", 1)
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(module.contents, (content, contentIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: contentIndex,
                    class: "content-item flex items-center justify-between rounded-xl border border-gray-200 px-3 py-2"
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("input", {
                          id: 'checkbox-' + module._id + '-' + contentIndex,
                          checked: content.completed,
                          class: "w-4 h-4 rounded-full border border-gray-300 bg-white text-primary appearance-none checked:bg-primary checked:border-primary focus:ring-2 focus:ring-primary",
                          type: "checkbox",
                          onChange: ($event: any) => (_ctx.onContentComplete(module._id, content._id))
                        }, null, 40, _hoisted_14)
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_PlayCircleIcon, { class: "h-5 w-5 text-gray-700" })
                      ]),
                      _createVNode(_component_router_link, {
                        to: '/dashboard/course/' + _ctx.course._id + '/' + module._id + '/' + content._id,
                        class: "text-gray-900 text-sm font-medium"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(content.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(content.length) + " min", 1)
                  ]))
                }), 128))
              ])
            ]),
            _: 2
          }, 1032, ["is-open", "progress", "onUpdate:isOpen"])
        ]))
      }), 128))
    ])
  ]))
}